import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront6 from "assets/images/servicii/bgFront6.webp";
import bgBack6 from "assets/images/servicii/bgBack6.webp";

const advantages = {
    paragraphs: [
        "Suntem printre cei mai apreciați furnizori de servicii profesionale de curățenie în întreținerea și curățarea suprafețelor textile.",
        "Deținem echipamente profesionale cu care putem realiza orice metodă de curățare a suprafețelor textile: pentru o curățare profesională rapidă și protejarea fibrelor sau pentru o curățare profundă și igienizare completă. Uscarea completă previne apariția mirosurilor neplăcute sau a mucegaiului.",
    ],
};

const advice = {
    paragraphs: [
        "Protejați mocheta: plasați la intrare traverse textile pentru preluarea murdăriei. Alegeți produse de calitate sau apelați la servicii de închiriere a acestora (costul depinde de frecvența înlocuirii).",
        "Indicați prestatorului de servicii informații despre articolele care necesită curățare.",
        "Este foarte important ca acestea să fie analizate în prealabil, în funcție de tipul de țesătură, compoziția fibrei, metoda de curățare adecvată și temperatura optimă de lucru, pentru a proteja materialul și a asigura o curățare eficientă și durabilă.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront6}
                                icon="touch_app"
                                title="Suprafețe textile și mochete"
                                description="Un proces tehnologic adaptat compoziției și structurii fiecărei fibre."
                            />
                            <RotatingCardBack
                                image={bgBack6}
                                title="Metode profesionale"
                                description="Solicită o evaluare gratuită."
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
